/* eslint-disable array-callback-return*/

import {
  defaultToastError,
  isNull,
  monthBeforeToday,
  today,
} from "App/utils/helpers"
import { useState, useEffect } from "react"
import {
  getHistoryPelayananPeserta,
  getKabupaten,
  getKecamatan,
  getKelasRawat,
  getProvinsi,
} from "./api"
import { getDataBridge } from "App/Component/layout/Manajemen/Dokter/utils"
import { defaultButtonSearch } from "../Modal/ModalKunjunganBaru"
import { DISABLED_BUTTON_SUBMIT } from "App/constants"

export const useKelasRawat = () => {
  const DEFAULT_OPTION = []
  const [state, setState] = useState(DEFAULT_OPTION)
  useEffect(() => {
    ;(async () => {
      const res = await getKelasRawat()
      if (res.state) {
        const data = []
        res.data.map((item) => {
          return data.push({
            value: item.kode,
            label: item.nama,
          })
        })

        setState(data)
      } else {
        setState([])
      }
    })()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return state
}

export const useProvinsi = () => {
  const DEFAULT_OPTION = []

  const [state, setState] = useState(DEFAULT_OPTION)
  useEffect(() => {
    ;(async () => {
      const res = await getProvinsi()
      if (res.state) {
        const data = []
        res.data.map((item) => {
          return data.push({
            value: item.kode,
            label: item.nama,
          })
        })

        setState(data)
      } else {
        setState([])
      }
    })()
  }, [])

  return state
}

export const useKabupaten = (kode) => {
  const DEFAULT_OPTION = []

  const [state, setState] = useState(DEFAULT_OPTION)
  useEffect(() => {
    ;(async () => {
      if (!isNull(kode)) {
        const res = await getKabupaten(kode)
        if (res.state) {
          const data = []
          res.data.map((item) => {
            return data.push({
              value: item.kode,
              label: item.nama,
            })
          })

          setState(data)
        } else {
          setState([])
        }
      }
    })()
  }, [kode])

  return state
}

export const useKecamatan = (kode) => {
  const DEFAULT_OPTION = []

  const [state, setState] = useState(DEFAULT_OPTION)
  useEffect(() => {
    ;(async () => {
      if (!isNull(kode)) {
        const res = await getKecamatan(kode)
        if (res.state) {
          const data = []
          res.data.map((item) => {
            return data.push({
              value: item.kode,
              label: item.nama,
            })
          })

          setState(data)
        } else {
          setState([])
        }
      }
    })()
  }, [kode])

  return state
}

export const useDokterSEP = () => {
  const [rows, setRows] = useState([])

  const setNewData = async () => {
    const response = await getDataBridge()
    const _temp = []
    if (response.state) {
      response.data.map((item) => {
        _temp.push({
          value: item.kodedokter,
          label: item.namadokter,
        })
      })

      setRows(_temp)
    } else {
      setRows([])
    }
  }

  useEffect(() => {
    setNewData()
  }, [])

  return rows
}

export const useSearchHistorySep = (noBpjs) => {
  const [disabled, setDisabled] = useState(defaultButtonSearch)
  const [rows, setRows] = useState([])
  const [filter, setFilter] = useState({
    valid_from: monthBeforeToday(2),
    valid_to: today(),
    no_bpjs: noBpjs,
  })

  const handleChange = (text) => (e) => {
    setFilter({
      ...filter,
      [text]: e.target.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setDisabled(DISABLED_BUTTON_SUBMIT)
    if (!isNull(filter.valid_from) && !isNull(filter.valid_to)) {
      await setNewData()

      setDisabled(defaultButtonSearch)
    }
  }

  const setNewData = async () => {
    const response = await getHistoryPelayananPeserta({
      no_bpjs: filter.no_bpjs,
      tgl_mulai: filter.valid_from,
      tgl_akhir: filter.valid_to,
    })

    if (response.state) {
      setRows(response.data)
    } else {
      defaultToastError(response.message)
      setRows([])
    }
  }

  return {
    disabled,
    rows,
    handleChange,
    handleSubmit,
    filter,
    setNewData,
  }
}
